<template>
  
  <div class="column" style="position: relative">



    <!-- image -->
    <div class="clip" v-if="image" style=" position: relative; background-size: cover; background-position: center; background-repeat: no-repeat; background-color: var(--back);" :style="{width:size, height:size, backgroundImage: `url(${image})`}"></div>

    <!-- letter -->
    <div class="column center clip" v-else :style="{width: size, height: size, backgroundColor: color}"> <span :style="{fontSize: size}">{{ letter }}</span> </div>

    <!-- online -->
     <div v-if="online" :style="{width: onlineSize, height: onlineSize}" style="position: absolute; top: 0; right: -0px; background-color: var(--online);border-radius: 200px;"></div>
    
</div>
    
</template>
<script>

/*

    <avatar :image="image" online name="james"/>
 
*/

export default {
    data: function () {return {
        colors: ['#0D4F39', '#2A3458', '#FFC107', '#F44336','#A3568F'],
    }},
    props:{
        size:{type:String, default:'200px'},        
        // width:{type:String, default:'200px'},        
        // height:{type:String, default:'200px'},        
        image: String,
        name: String,
        online: Boolean, 
        onlineSize: {type: String, default:'8px'}, 
    },
    mounted() {
        // console.log('ImageMask', this.image)
    },
    
    computed:{
        letter(){
            if (!this.name) return 'D'
            let letter = this.name[0]
            return letter.toUpperCase()
        },
        color(){
            let ints = function(s) {
                return s.split("").reduce(function(a, b) {
                    a = ((a << 5) - a) + b.charCodeAt(0);
                    return a & a;
                }, 0);
            }
            let name = this.name || 'DEMO'
            let num = ints(name)
            let colors = this.colors
            console.log('avatar color', num)
            // return colors[num % colors.length]
            return 'var(--primary)'
        }
    },
    methods: {
        // click(){
        //     this.$emit('click');
        // },
        
        
    },
}
</script>

<style scoped>
.masked{    
  mask-image: url('data:image/svg+xml,<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_1923_7436)"><rect width="200" height="200" fill="white"/><path d="M100 0C22.2222 0 0 22.2222 0 100C0 177.778 22.2778 200 100 200C177.722 200 200 177.778 200 100C200 22.2222 177.722 0 100 0Z" fill="black"/></g><defs><clipPath id="clip0_1923_7436"><rect width="200" height="200" fill="white"/></clipPath></defs></svg>');
  mask-mode: alpha;
  -webkit-mask-image: url('data:image/svg+xml,<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_1923_7436)"><rect width="200" height="200" fill="white"/><path d="M100 0C22.2222 0 0 22.2222 0 100C0 177.778 22.2778 200 100 200C177.722 200 200 177.778 200 100C200 22.2222 177.722 0 100 0Z" fill="black"/></g><defs><clipPath id="clip0_1923_7436"><rect width="200" height="200" fill="white"/></clipPath></defs></svg>');
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
}

.maskeddiv {
  width: 200px;
  height: 200px;
  /* background: linear-gradient(45deg, #3498db, #9b59b6); */
  
  /* SVG-маска */
  mask-image: url('data:image/svg+xml,<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_1923_7436)"><rect width="200" height="200" fill="white"/><path d="M100 0C22.2222 0 0 22.2222 0 100C0 177.778 22.2778 200 100 200C177.722 200 200 177.778 200 100C200 22.2222 177.722 0 100 0Z" fill="black"/></g><defs><clipPath id="clip0_1923_7436"><rect width="200" height="200" fill="white"/></clipPath></defs></svg>');
  -webkit-mask-image: url('data:image/svg+xml,<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_1923_7436)"><rect width="200" height="200" fill="white"/><path d="M100 0C22.2222 0 0 22.2222 0 100C0 177.778 22.2778 200 100 200C177.722 200 200 177.778 200 100C200 22.2222 177.722 0 100 0Z" fill="black"/></g><defs><clipPath id="clip0_1923_7436"><rect width="200" height="200" fill="white"/></clipPath></defs></svg>');
  
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
}

.clip{
 clip-path: polygon( 50% 0%,50% 0%,39.15% 0.35%,29.867% 1.467%,22.05% 3.45%,15.6% 6.4%,10.417% 10.417%,6.4% 15.6%,3.45% 22.05%,1.467% 29.867%,0.35% 39.15%,0% 50%,0% 50%,0.351% 60.85%,1.469% 70.133%,3.455% 77.95%,6.408% 84.4%,10.427% 89.583%,15.612% 93.6%,22.062% 96.55%,29.877% 98.533%,39.157% 99.65%,50% 100%,50% 100%,60.843% 99.65%,70.123% 98.533%,77.938% 96.55%,84.388% 93.6%,89.573% 89.583%,93.592% 84.4%,96.545% 77.95%,98.531% 70.133%,99.649% 60.85%,100% 50%,100% 50%,99.649% 39.15%,98.531% 29.867%,96.545% 22.05%,93.592% 15.6%,89.573% 10.417%,84.388% 6.4%,77.938% 3.45%,70.123% 1.467%,60.843% 0.35%,50% 0%);  
}
</style>

